// extracted by mini-css-extract-plugin
export default {"uploadwidget":"UploadWidget_uploadwidget__Sr9gw","uploadwidget__cover":"UploadWidget_uploadwidget__cover__CEMrE"};